import { IMAGES } from "@/lib/site";

const ROUTES = [
  { code: "LBA", label: "Leeds Bradford • 25 mins" },
  { code: "MAN", label: "Manchester • 65 mins" },
  { code: "NCL", label: "Newcastle • 100 mins" },
  { code: "EMA", label: "East Midlands • 80 mins" },
];

export const Coverage = () => (
  <section id="coverage" className="relative scroll-mt-20 overflow-hidden border-b border-white/10 py-24" data-testid="coverage-section">
    <img src={IMAGES.fullBleed} alt="Highway leading towards an illuminated airport runway at dusk" loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
    <div className="absolute inset-0 bg-[#0b101b]/80 backdrop-blur-[2px]"></div>

    <div className="relative z-10 mx-auto max-w-6xl px-6 text-center">
      <span className="font-mono-lbl text-xs uppercase tracking-[0.25em] text-[#38bdf8]">Regional Route Coverage</span>
      <h2 className="mx-auto mb-8 mt-4 max-w-3xl font-disp text-4xl uppercase leading-tight text-white sm:text-6xl">
        Connecting Yorkshire Doorsteps to Every Major UK Terminal
      </h2>
      <div className="mx-auto grid max-w-4xl grid-cols-2 gap-6 font-mono-lbl text-xs text-slate-300 sm:grid-cols-4">
        {ROUTES.map((r) => (
          <div key={r.code} data-testid={`route-card-${r.code.toLowerCase()}`} className="rounded-xl border border-white/10 bg-black/40 p-4">
            <div className="font-disp text-2xl text-[#38bdf8]">{r.code}</div>
            <div>{r.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
